/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 17:45:21
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './productWithdrawalManagement.module.css'
const { Option } = Select

export const Query = (props: {
  loading?: any
  exportLoading?: any
  onValueChange: (params: any) => void
  export: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        props.onValueChange({
          ...values,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%', height: '42px' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='materialsName' noStyle>
            <Input
              style={{ width: '150px' }}
              allowClear={true}
              placeholder='关键字'
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export && props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
